/**
 * 訂單相關共用 Schema
 * 由 shared 常數衍生，供前後端與 OpenAPI 共用
 */
import { z } from 'zod';
import { ORDER_STATUS, PAYMENT_STATUS, SHIPPING_STATUS, } from '../constants/orders.js';
/** 訂單狀態 Schema（成立／作廢） */
export const OrderStatusSchema = z.enum([
    ORDER_STATUS.CONFIRMED,
    ORDER_STATUS.VOIDED,
]);
/** 付款狀態 Schema */
export const PaymentStatusSchema = z.enum(Object.values(PAYMENT_STATUS));
/** 出貨狀態 Schema */
export const ShippingStatusSchema = z.enum(Object.values(SHIPPING_STATUS));
